import { useQuery } from '@apollo/client';
import { GET_CUSTOMER_RFID_TOKENS } from '@queries/getCustomerRfidTokens';
import { Query, RfidToken } from 'types/generatedSchemaTypes.ts';

const useGetCustomerRfidTokens = (): RfidToken[] => {
  const { data: { readRfidTokens: rfidTokens } = {} } = useQuery<Query>(
    GET_CUSTOMER_RFID_TOKENS,
    {
      fetchPolicy: 'cache-and-network',
    }
  );
  return rfidTokens?.filter(Boolean) as RfidToken[];
};

export default useGetCustomerRfidTokens;
